import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const Header = () => {
  const { t, i18n } = useTranslation();

  // 语言切换逻辑
  const toggleLanguage = () => {
    const nextLang = i18n.language.startsWith('zh') ? 'en' : 'zh';
    i18n.changeLanguage(nextLang);
  };

  return (
    // 微调：在小屏幕下减小两边内边距 (px-4)，大屏恢复 px-8
    <header className="flex items-center justify-between px-4 md:px-8 py-4 bg-[#f2f2f2]/90 backdrop-blur-md sticky top-0 z-50">
      
      {/* 左侧：Logo 区 */}
      {/* 【关键修复】：加上 shrink-0 防止被压缩 */}
      <div className="flex items-center gap-2 shrink-0">
        {/* 修改：将原来的灰色 div 替换为图片引用的 img 标签 */}
        <img 
          src="/assets/icons/leaf-icon.png" 
          alt="Logo" 
          className="w-8 h-8 shrink-0 object-contain" 
        /> 
        {/* 【关键修复】：加上 whitespace-nowrap 绝对禁止品牌名换行 */}
        <span className="text-xl font-bold tracking-wide whitespace-nowrap">{t('site.brandName')}</span>
      </div>

      {/* 中间：核心导航 */}
      {/* 【关键修复】：将 md:flex 改为 lg:flex。因为导航项很多，768px 宽度根本放不下，1024px 展开才不会和两边挤在一起 */}
      <nav className="hidden lg:flex items-center gap-6 xl:gap-8 text-sm text-gray-700 whitespace-nowrap">
        <Link to="/" className="hover:text-black transition-colors">{t('header.products')}</Link>
        <Link to="/products/hygro" className="hover:text-black transition-colors">{t('header.hygro')}</Link>
        <Link to="/products/bin" className="hover:text-black transition-colors">{t('header.bin')}</Link>
        <Link to="/contact" className="hover:text-black transition-colors">{t('header.contact')}</Link>
      </nav>

      {/* 右侧：操作区 */}
      {/* 【关键修复】：加上 shrink-0 防止右侧区域被挤压 */}
      <div className="flex items-center gap-4 md:gap-6 text-sm text-gray-700 shrink-0">
        {/* 微调：手机端空间太小，About 可以选择在小屏隐藏 (hidden sm:block)，或者保持显示 */}
        <Link to="/about" className="hover:text-black transition-colors whitespace-nowrap hidden sm:block">
          {t('header.about')}
        </Link>
        
        {/* 动态语言切换按钮 */}
        <div 
          onClick={toggleLanguage}
          className="cursor-pointer hover:text-black transition-colors select-none whitespace-nowrap"
        >
          {t('header.langSwitch')}
        </div>
        
        {/* 【关键修复】：加上 whitespace-nowrap 绝对禁止按钮文字断行 */}
        <button className="px-4 py-1.5 md:px-5 border border-gray-400 rounded-full hover:bg-gray-200 transition-colors whitespace-nowrap">
          {t('header.enterEcosystem')}
        </button>
      </div>
    </header>
  );
};